import React from 'react';
import { Card, Form, Row, Col } from 'react-bootstrap';

const Attendance = ({ formData, handleFormChange }) => {
  return (
    <Card className="dark-main-card text-light">
      <Card.Body className="p-3 compact-form">
        <h3 className="mb-3 text-white" style={{ fontSize: "1.5rem" }}>Attendance</h3>
        <Row>
          <Col md={6}>
            <Form.Group className="mb-2" controlId="expectedAttendance">
              <Form.Label>Expected Attendance</Form.Label>
              <Form.Control
                type="number"
                name="expectedAttendance"
                value={formData.expectedAttendance}
                onChange={handleFormChange}
                className="dark-input"
              />
            </Form.Group>
          </Col>
          <Col md={6}>
            <Form.Group className="mb-2" controlId="vipAttendees">
              <Form.Label>VIP Attendees</Form.Label>
              <Form.Control
                type="number"
                name="vipAttendees"
                value={formData.vipAttendees}
                onChange={handleFormChange}
                className="dark-input"
              />
            </Form.Group>
          </Col>
        </Row>
        <Form.Group className="mb-2" controlId="attendeeDemographics">
          <Form.Label>Attendee Demographics</Form.Label>
          <Form.Control
            as="select"
            multiple
            name="attendeeDemographics"
            value={formData.attendeeDemographics}
            onChange={handleFormChange}
            className="dark-input"
          >
            <option value="age_18_25">Age 18-25</option>
            <option value="age_26_35">Age 26-35</option>
            <option value="age_36_45">Age 36-45</option>
            <option value="age_46_55">Age 46-55</option>
            <option value="age_55_plus">Age 55+</option>
            <option value="tech">Tech</option>
            <option value="finance">Finance</option>
            <option value="marketing">Marketing</option>
            <option value="healthcare">Healthcare</option>
            <option value="education">Education</option>
            <option value="sports">Sports</option>
            <option value="music">Music</option>
            <option value="travel">Travel</option>
            <option value="food">Food</option>
            <option value="books">Books</option>
          </Form.Control>
        </Form.Group>
        <Form.Group className="mb-2" controlId="specialAccommodations">
          <Form.Label>Special Accommodations Needed</Form.Label>
          <Form.Control
            as="textarea"
            rows={3}
            name="specialAccommodations"
            value={formData.specialAccommodations}
            onChange={handleFormChange}
            className="dark-input"
          />
        </Form.Group>
      </Card.Body>
    </Card>
  );
};

export default Attendance;